/*
 * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
 * #  This file forms part of the Trade-DSM application frontend.
 * #  https://github.com/Tooblippe/trade-dsm-frontend
 */

export default {
  methods: {
    setProgressMessage: function (message) {
      this.$store.commit('setProgressMessage', message);
    },
    setFilterIsDirty: function (bool) {
      this.$store.commit('setFilterIsDirty', bool);
    },
  },

  computed: {
    progressMessage: function () {
      return this.$store.getters.getProgressMessage;
    },
    filterIsDirty: function () {
      return this.$store.getters.getFilterIsDirty;
    },
  },
};
